import React  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { GetRooms } from '../../../api/services/pms';

const RoomsDropDown = ({...rest}) => {

    return <DropDown search api={GetRooms} textField="Name" descriptionField="Number" valueField="Id" {...rest}/>
}

RoomsDropDown.propTypes = {
    roomTypes: PropTypes.any,
    HotelID: PropTypes.any
}
export default RoomsDropDown
